import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";

function SignOut() {
  const navigate = useNavigate();

  useEffect(() => {
    const logout = async () => {
      try {
        const auth = getAuth(); //
        await signOut(auth); //
        navigate("/authentication/sign-in"); //
      } catch (error) {
        console.error("Sign out failed:", error);
      }
    };

    logout();
  }, [navigate]);

  return null;
}

export default SignOut;
